
/*
 * VORI Jewelry — Complimentary Gift Box
 * Shopify Dawn
 */

(() => {
  const GIFT_ID = 68285132472571;
  const GIFT_PROPERTY = '_vori_complimentary';
  const ROOT = window.Shopify?.routes?.root || '/';

  let processing = false;
  let pending = false;
  let timer = null;
  let giftDisabled = false;

  const isOurGift = (item) =>
    Number(item.variant_id) === GIFT_ID &&
    item.properties?.[GIFT_PROPERTY] === 'yes';

  async function getCart() {
    const response = await fetch(`${ROOT}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) throw new Error('Cannot read cart');
    return response.json();
  }

  async function postCart(path, data) {
    const response = await fetch(`${ROOT}${path}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    });

    const result = await response.json();

    if (!response.ok || result.errors) {
      throw new Error(result.description || 'Cart update failed');
    }

    return result;
  }

  async function hasEligibleJewelry() {
    const response = await fetch(
      `${ROOT}cart?section_id=vori-gift-status`,
      {
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error('Gift eligibility section unavailable');
    }

    const html = await response.text();
    const documentHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const element = documentHTML.querySelector(
      '[data-vori-gift-eligible]'
    );

    if (!element) {
      throw new Error('Gift eligibility cannot be verified');
    }

    return element.dataset.voriGiftEligible === 'true';
  }

  async function removeGift(item) {
    await postCart('cart/change.js', {
      id: item.key,
      quantity: 0
    });
  }

  async function refreshCartDisplay(cart) {
    const mainItems = document.getElementById('main-cart-items');
    const mainFooter = document.getElementById('main-cart-footer');

    const sections = ['cart-icon-bubble'];

    if (document.querySelector('cart-drawer')) {
      sections.push('cart-drawer');
    }

    if (mainItems?.dataset.id) {
      sections.push(mainItems.dataset.id);
    }

    if (mainFooter?.dataset.id) {
      sections.push(mainFooter.dataset.id);
    }

    const response = await fetch(
      `${ROOT}cart?sections=${sections.join(',')}`,
      { credentials: 'same-origin', cache: 'no-store' }
    );

    if (!response.ok) throw new Error('Cart refresh failed');

    const rendered = await response.json();
    const parser = new DOMParser();

    const iconHTML = rendered['cart-icon-bubble'];

    if (iconHTML) {
      const newIcon = parser
        .parseFromString(iconHTML, 'text/html')
        .querySelector('#cart-icon-bubble');

      const currentIcon = document.querySelector(
        '#cart-icon-bubble'
      );

      if (newIcon && currentIcon) {
        currentIcon.innerHTML = newIcon.innerHTML;
      }
    }

    const drawer = document.querySelector('cart-drawer');

    if (drawer && rendered['cart-drawer']) {
      const newDocument = parser.parseFromString(
        rendered['cart-drawer'],
        'text/html'
      );

      const newInner = newDocument.querySelector(
        'cart-drawer .drawer__inner'
      );

      const currentInner = drawer.querySelector('.drawer__inner');

      if (newInner && currentInner) {
        currentInner.replaceWith(newInner);

        drawer.classList.toggle(
          'is-empty',
          cart.item_count === 0
        );

        drawer.querySelector('#CartDrawer-Overlay')
          ?.addEventListener('click', () => drawer.close());
      }
    }

    for (const target of [mainItems, mainFooter]) {
      if (!target?.dataset.id) continue;

      const sectionHTML = rendered[target.dataset.id];
      if (!sectionHTML) continue;

      const newDocument = parser.parseFromString(
        sectionHTML,
        'text/html'
      );

      const newTarget = newDocument.getElementById(target.id);
      const newContent = newTarget?.querySelector('.js-contents');
      const currentContent = target.querySelector('.js-contents');

      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
        target.classList.toggle(
          'is-empty',
          cart.item_count === 0
        );
      }
    }
  }

  async function synchronizeGift() {
    if (processing) {
      pending = true;
      return;
    }

    processing = true;
    let changed = false;

    try {
      let cart = await getCart();
      const eligible = await hasEligibleJewelry();

      const gifts = cart.items.filter(isOurGift);

      if (!eligible) {
        for (const gift of gifts) {
          await removeGift(gift);
          changed = true;
        }
      } else if (!giftDisabled) {
        const existingGift = cart.items.some(
          (item) => Number(item.variant_id) === GIFT_ID
        );

        if (!existingGift) {
          await postCart('cart/add.js', {
            items: [{
              id: GIFT_ID,
              quantity: 1,
              properties: {
                [GIFT_PROPERTY]: 'yes'
              }
            }]
          });

          changed = true;
        }

        cart = await getCart();

        const complimentaryGifts = cart.items.filter(isOurGift);

        for (const gift of complimentaryGifts) {
          if (gift.quantity !== 1) {
            await postCart('cart/change.js', {
              id: gift.key,
              quantity: 1
            });
            changed = true;
          }
        }

        cart = await getCart();

        for (const gift of cart.items.filter(isOurGift)) {
          if (gift.final_line_price !== 0) {
            await removeGift(gift);
            giftDisabled = true;
            changed = true;

            console.warn(
              'VORI: Gift removed because the 100% discount did not apply.'
            );
          }
        }
      }

      if (changed) {
        await refreshCartDisplay(await getCart());
      }
    } catch (error) {
      console.error('VORI Gift Box:', error);

      if (changed) {
        window.location.reload();
        return;
      }
    } finally {
      processing = false;

      if (pending) {
        pending = false;
        scheduleSync();
      }
    }
  }

  function scheduleSync(delay = 350) {
    clearTimeout(timer);
    timer = setTimeout(synchronizeGift, delay);
  }

  function initialize() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        scheduleSync(500);
      });
    }

    scheduleSync(500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
